<template>
    <div :class="appearance === 'black' ? 'fin-bg-white fin-text-black' : 'fin-bg-black fin-text-white'">
        <el-table
            ref="leadToSettleTable"
            :data="_.orderBy(_.get(brokerBreakdownData, 'statsByBroker'), ['settled_mtd'], ['desc'])"
            stripe
            highlight-current-row
            :border="false"
            :show-summary="true"
            :default-sort="{prop: 'settled_mtd', order: 'descending'}"
            sum-text="Total"
            class="mb-4 fin-h-full"
            style="width: 100%;">
            <el-table-column
                prop="broker_name"
                label="Broker"
                label-class-name="text-center"
                class-name="font-weight-bold"
                min-width="150"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="Daily" label-class-name="text-center text-uppercase">
                <el-table-column label="Leads" label-class-name="text-center">
                    <el-table-column
                        prop="leads_today"
                        label="New"
                        label-class-name="text-center">
                    </el-table-column>
                    <el-table-column
                        prop="nocontact_today"
                        label="No Contact"
                        label-class-name="text-center">
                    </el-table-column>
                    <el-table-column
                        prop="junk_today"
                        label="Junk"
                        label-class-name="text-center">
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    prop="apps_today"
                    label="Apps"
                    label-class-name="text-center align-bottom">
                </el-table-column>
                <el-table-column
                    prop="options_today"
                    label="Options"
                    label-class-name="text-center align-bottom">
                </el-table-column>
                <el-table-column
                    prop="settled_today"
                    label="Settled"
                    label-class-name="text-center align-bottom">
                </el-table-column>
            </el-table-column>
            <el-table-column label="Month To Date" label-class-name="text-center text-uppercase">
                <el-table-column label="Leads" label-class-name="text-center">
                    <el-table-column
                        prop="leads_mtd"
                        label="New"
                        label-class-name="text-center">
                    </el-table-column>
                    <el-table-column
                        prop="nocontact_mtd"
                        label="No Contact"
                        label-class-name="text-center">
                    </el-table-column>
                    <el-table-column
                        prop="junk_mtd"
                        label="Junk"
                        label-class-name="text-center">
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    prop="apps_mtd"
                    label="Apps"
                    label-class-name="text-center align-bottom">
                </el-table-column>
                <el-table-column
                    prop="options_mtd"
                    label="Options"
                    label-class-name="text-center align-bottom">
                </el-table-column>
                <el-table-column
                    prop="settled_mtd"
                    label="Settled"
                    label-class-name="text-center align-bottom">
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'BrokerBreakdown',
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            brokerBreakdownData: [],
        }
    },
    watch: {
        'brokerBreakdownData': {
            handler(val) {
                if (_.size(val)) {
                    let leadToSettleTable = this.$refs.leadToSettleTable;

                    if (leadToSettleTable) {
                        setTimeout(function () {
                            leadToSettleTable.doLayout();
                        }, 1000);
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.brokerBreakdownData = event.brokerBreakdowns.brokerBreakdowns

            this.graphColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.brokerBreakdownData = event.brokerBreakdowns.brokerBreakdowns

            this.graphColorChange()
        })
    },
    computed: {},
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>

</style>

<style>
.dashboard-lts-widget .el-table__empty-block {
    min-height: 30px;
}

.dashboard-lts-widget .el-table td {
    font-size: 12px;
    padding: 3px 0;
}

.dashboard-lts-widget .el-table th {
    font-size: 12px;
    padding: 5px 0;
}

.dashboard-lts-dialog .el-table__footer-wrapper .cell {
    text-align: left !important;
    font-weight: 900;
}

.dashboard-lts-dialog .el-dialog__wrapper {
    overflow: hidden;
}

.dashboard-lts-dialog .el-table__body-wrapper {
    max-height: calc(100vh - 420px);
    overflow-y: scroll;
}

.dashboard-lts-dialog .el-dialog__wrapper div[role=dialog] {
    width: calc(100vw - 40px);
    max-width: 2000px;
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.lead-settle-datepicker .el-input__inner {
    border-radius: 0;
    border-color: #ccc;
}

.lead-settle-datepicker .el-input__inner {
    border-radius: 0;
    border-color: #C0C4CC;
}

.lead-settle-datepicker.is-active .el-input__inner, .lead-settle-datepicker .el-input__inner:focus {
    border-color: #409EFF;
    outline: 0;
}

.dashboard-lts-dialog .el-dialog__body {
    padding: 10px 20px;
}

.dashboard-lts-dialog .el-table__body tr.current-row > td {
    background-color: #D4AF37 !important;
    color: white;
}

.dashboard-lts-dialog .el-table--enable-row-hover .el-table__body tr:not(.current-row):hover > td {
    background-color: #dae4ec !important;
}

.dashboard-lts-dialog .el-table__body tr:hover > td {
    cursor: pointer;
}

.dashboard-lts-dialog .el-dialog__close {
    font-size: 26px !important;
    font-weight: 900;
}

</style>
